import AppManagerClient from '../../api/AppManagerClient';
import { IManagingAppPoolsInstance } from '../../api/models';
import React, { useEffect } from 'react';
import { AppPoolsInfoView } from './AppPoolsInfoView';
import { Merger } from '../../helpers/Merger';

export const AppPoolsInfo = (props: any) => {
    const [serverApps, setServerApps]: [IManagingAppPoolsInstance[], Function] = React.useState([]);
    const [isLoading, setLoadingStatus] = React.useState(true);
    const [errorMessage, setErrorMessage] = React.useState('');
    const applicationName = props.applicationName;

    const getServers = async (appName: string) => {
        try {
            const serversResult = await AppManagerClient.getAppPoolsForManaging(appName);
            setServerApps(serversResult);
        } catch (err: any) {
            setErrorMessage(err.message);
        } finally {
            setLoadingStatus(false);
        }
    };

    useEffect(() => {
        getServers(applicationName);
    }, [applicationName]);

    return (
        <AppPoolsInfoView
            serverApps={Merger.merge(serverApps)}
            isLoading={isLoading}
            errorMessage={errorMessage}
            isDataNotFound={serverApps.length === 0}
            applicationName={applicationName}
        />
    );
};
